const WorkroomProjectInfoService = class WorkroomProjectInfoService {
  constructor () {
    'ngInject'
  }
}
export default WorkroomProjectInfoService
